import React from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

import { DashboardContext } from '../DashboardContext';
import { DashboardLoading } from './DashboardLoading';
import { DashboardStatus } from '../enums/DashboardStatus';

const useStyles = makeStyles(() => createStyles({
    powerBi: {
        height: '90vh',
        boarder: 'none',
        overflow: 'hidden'
    },
    invisible: { 
        visibility: 'hidden',
        overflow: 'hidden'
    }
}));

export function PowerBIDashboard() {
    const classes = useStyles();
    const dashboardContext = React.useContext(DashboardContext);

    const [rendered, setRendered] = React.useState<boolean>(false);

    return (
        <>
            { !rendered && <DashboardLoading /> }
            <PowerBIEmbed
                embedConfig = {{
                    id: dashboardContext.embedParams.embedReport.reportId,
                    type: 'report', 
                    embedUrl: dashboardContext.embedParams.embedReport.embedUrl,
                    accessToken: dashboardContext.embedParams.embedToken.token,
                    tokenType: models.TokenType.Embed,
                    permissions: models.Permissions.All,
                    pageName: dashboardContext.embedParams.embedReport.pageName,
                    settings: {
                        panes: {
                            filters: {
                                expanded: false,
                                visible: false
                            },
                            pageNavigation: {
                                visible: false
                            }
                        },
                        background: models.BackgroundType.Transparent,
                    },
                }}
		
                cssClassName = { rendered ? classes.powerBi : classes.invisible }

                eventHandlers = { 
                    new Map([
                        ['loaded', () => {
                            setRendered(true);
                        }],
                        ['rendered', () => {
                            setRendered(true);
                        }],
                        ['error', (event: any) => {
                            dashboardContext.setDashboardStatus(DashboardStatus.ERROR);
                            dashboardContext.setErrorMessage(event.detail);
                        }]
                    ])
                }
            />
        </>
    );
}